import React from 'react'

import styles from './Footer.module.css'

const spaces = [
  { name: 'Bio', href: 'https://meinstein.github.io' },
  { name: 'Github', href: 'https://github.com/meinstein' },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/maxeinstein'
  },
  { name: 'Instagram', href: 'https://meinstein.github.io/ig-me' }
]

export default () => (
  <footer className={styles.footer}>
    {spaces.map((space, idx) => (
      <>
        <a key={idx} className={styles.space} target="_blank" rel="noopener noreferrer" href={space.href}>
          {space.name}
        </a>
        {idx !== spaces.length - 1 && <span>|</span>}
      </>
    ))}
  </footer>
)
